import { useEffect } from 'react';

const SITE_NAME = 'MaximGun';
const DEFAULT_TITLE = 'MaximGun — цифровой архив пулемётов системы Максима';

/** Sets the browser tab title for a record page and resets it on leave. */
export function useDocumentTitle(title) {
  useEffect(() => {
    if (!title) return undefined;
    document.title = `${title} — ${SITE_NAME}`;
    // nginx may have rendered this record's title into the page, so never restore "previous".
    return () => { document.title = DEFAULT_TITLE; };
  }, [title]);
}
